"use strict";
/*
 * Created on 05 04 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * <p>Input for computation of Sellout impact report extracted from {@link SelloutReleaseItem}. Only items with exported prices
 * (non-empty exportedPriceHistory) are considered.</p>
 *
 * @author Jaroslav Sevcik
 */
//TODO Move to common-be.


var SelloutReleaseImpactComputationInput =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutReleaseImpactComputationInput, _DomainObject_1$Domai);

  /**
   * Ctor (minimized attributes length due to possible serialization to DB -> saves memory, saves time).
   * <br/>
   * Each attribute should be exaggeratedly described.
   *
   * @param iId Identification of the release item.
   * @param pId Identification of the associated product.
   * @param rId Identification of the associated release.
   * @param sellType Sellout release type
   * @param supId Identification of the associated supplier.
   * @param vFrom Price validity start of related price validity interval.
   * @param vTo Price validity end of related price validity interval.
   * @param mOld Expected margin for old price (see desc. within source data for more info).
   * @param mNew Expected margin for new price (see desc. within source data for more info).
   * @param pOld Expected profit for old price (see desc. within source data for more info).
   * @param pNew Expected profit for new price (see desc. within source data for more info).
   * @param vA Vendor allowance bonus (value is percentage number). Vendor allowance value may not be specific to segment, but
   *        for simplicity, modeled as segment specific.
   * @param fOld Forecast amount for one day for old price.
   * @param fNew Forecast amount for one day for new price.
   * @param sPrice Sellout price - the price suggested by the optimization engine.
   * @param prevPrice Previous valid price (more or less). It is the price send to the optimization engine as a previous price.
   *        See {@link SelloutReleaseItemPrices#regularPrice}
   * @param pPrice Purchase price (purchasePrice.avgPrice.value)
   */
  function SelloutReleaseImpactComputationInput(iId, pId, rId, sellType, supId, vFrom, vTo, mOld, mNew, pOld, pNew, vA, fOld, fNew, sPrice, prevPrice, pPrice) {
    var _this;

    _classCallCheck(this, SelloutReleaseImpactComputationInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseImpactComputationInput).call(this));
    _this.iId = iId;
    _this.pId = pId;
    _this.rId = rId;
    _this.sellType = sellType;
    _this.supId = supId;
    _this.vFrom = vFrom;
    _this.vTo = vTo;
    _this.mOld = mOld;
    _this.mNew = mNew;
    _this.pOld = pOld;
    _this.pNew = pNew;
    _this.vA = vA;
    _this.fOld = fOld;
    _this.fNew = fNew;
    _this.sPrice = sPrice;
    _this.prevPrice = prevPrice;
    _this.pPrice = pPrice;
    return _this;
  }

  return SelloutReleaseImpactComputationInput;
}(DomainObject_1.DomainObject);

exports.SelloutReleaseImpactComputationInput = SelloutReleaseImpactComputationInput;